import React from 'react'
import { t } from '../../../i18n'
import { CommandButton, ControlGroupKey } from '../types'
import ActionButton from './ActionButton'

const scope = 'controls'

interface Props {
  groupKey: ControlGroupKey
  commands: CommandButton[]
  paramKey: string
  commandOrder: string[]
  footerCommandOrder?: string[]
  gridClassName: string
}

const groupByInstance = (buttons: CommandButton[], paramKey: string): Record<string, CommandButton[]> => {
  const groups: Record<string, CommandButton[]> = {}
  buttons.forEach(b => {
    const key = String(b.params[paramKey] ?? '')
    groups[key] ||= []
    groups[key].push(b)
  })
  return groups
}

const sortInstanceKeys = (groups: Record<string, CommandButton[]>): string[] =>
  Object.keys(groups).sort((a, b) => Number(a) - Number(b))

const renderOrderedButtons = (keys: string[], groups: Record<string, CommandButton[]>, order: string[]) =>
  keys.flatMap(key =>
    order.map(cmdName => {
      const button = groups[key].find(b => b.command === cmdName)
      if (!button) return null
      return <ActionButton key={button.name} command={button} />
    })
  )

const PerInstanceRows = ({ groupKey, commands, paramKey, commandOrder, footerCommandOrder = [], gridClassName }: Props) => {
  const groups = groupByInstance(commands, paramKey)
  const keys = sortInstanceKeys(groups)

  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="card-title mb-3">{t(`groups.${groupKey}`, { scope })}</h6>
        {commands.length === 0 ? (
          <div className="text-muted fst-italic">—</div>
        ) : (
          <>
            <div className={gridClassName}>
              {renderOrderedButtons(keys, groups, commandOrder)}
            </div>
            {footerCommandOrder.length > 0 && (
              <div className={`${gridClassName} mt-3`}>
                {renderOrderedButtons(keys, groups, footerCommandOrder)}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default PerInstanceRows
